import { BaseModel } from "../base-model";
import { UserInfoModel } from "./user-info.model";
import { SiteInfoModel } from '../site/site-info.model';

export interface IAuthConfigModel {
	IsMultiSites?: boolean;
	UserInfo?: UserInfoModel;
	BaseIconResourceUrl?: string;
	ShareResourceUrl?: string;
	SiteInfo?: SiteInfoModel;
    Config?: IUserConfiguration;
    IsMasterUser?: boolean;
    IsMasterPassword?: boolean;
    PasswordType?: string;
    MailSenderWarning?: IMailSenderWarning | null;

}

export interface IMailSenderWarning {
    Show: boolean;
    Message?: string;
}
export class AuthConfigModel extends BaseModel<IAuthConfigModel>
	implements IAuthConfigModel {
	IsMultiSites?: boolean;
	UserInfo?: UserInfoModel;
	BaseIconResourceUrl?: string;
	ShareResourceUrl?: string;
	SiteInfo?: SiteInfoModel;
	Config?: IUserConfiguration;
	/**
	 *
	 */
	constructor(options?: IAuthConfigModel) {
		super(options);
	}
}

export interface IUserConfiguration {
	CityTextTransform?: number;
	LanguageID?: string | number;
	CityMultipleLanguage?: number;
	HtmlEditorFontColor: string;
	HtmlEditorFontName: string;
	HtmlEditorFontSize: number;
    OfficeLanguageId: number;
    IsAllowDeleteHistory?: boolean;
	EnableElasticSearch?: boolean;
	ShowDashboardModule?: boolean;
	OpenAppointmentType?: number;
	UseInstagramOfficial?: boolean;
}

export class UserConfiguration extends BaseModel<IUserConfiguration>{
	constructor(options?: IUserConfiguration) {
		super(options);
	}
}